import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper } from '@mui/material';
import api from '../api/axios';

// Define the expected response type
type LoginResponse = {
  access_token: string;
  user: {
    role?: { is_super_admin?: boolean; name?: string };
    tenant_id?: number;
    // ...other user fields if needed
  };
};

const LoginPage: React.FC<{ onLogin: (user: any) => void }> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/v1/auth/login/json', { email, password });
      const data = res.data as LoginResponse;
      // Store minimal data in localStorage (not ideal but functional)
      localStorage.setItem('token', data.access_token);
      
      // Set user role and tenant ID for role-based access
      const userRole = data.user.role?.is_super_admin ? 'super_admin' : 'admin';
      localStorage.setItem('userRole', userRole);
      if (data.user.tenant_id) {
        localStorage.setItem('userTenantId', data.user.tenant_id.toString());
      }
      
      // Store user data in sessionStorage (more secure than localStorage)
      sessionStorage.setItem('user', JSON.stringify(data.user));
      
      api.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
      if (!data.user.role?.is_super_admin && data.user.role?.name !== 'admin') {
        setError('Not an admin or super admin.');
        return;
      }
      onLogin(data.user);
    } catch (err: any) {
      setError('Invalid credentials or not an admin.');
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper sx={{ p: 4, minWidth: 320 }}>
        <Typography variant="h4" align="center" gutterBottom>
          RJJ MGT Login
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage; 